<h2 mat-dialog-title>Errors</h2>
<mat-dialog-content>
  <mat-form-field class="d-block">
    <textarea matInput cdkTextareaAutosize [cdkAutosizeMinRows]="20" [value]="errorStore.errors().join('\n')"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button (click)="onClear()">Clear</button>
  <button mat-button (click)="onCopyErrors()">Copy All</button>
  <button mat-button (click)="onReport()">Report</button>
</mat-dialog-actions>